const whenShoulIGoToPsychiatrist = {
    'question': 'Kiedy warto rozważyć wizytę u psychiatry? Jakie objawy mogą na to wskazywać?',
    'answer': 'Wizyta u psychiatry jest zalecana, gdy objawy zaburzania ' +
        'psychicznego wyraźnie pogarszają jakość życia i codzienne funkcjonowanie. ' +
        'Typowe sygnały to m.in. przewlekły zły nastrój, stale odczuwany lęk lub napięcie, ' +
        'drastyczne wahania nastroju i emocji, problemy ze snem lub koncentracją, myśli samobójcze. ' +
        'Leczenie psychiatryczne pomaga zmniejszyć dolegliwości i poprawić samopoczucie. ' +
        'Im szybciej się je rozpocznie, tym lepsze daje efekty.'
}

export default whenShoulIGoToPsychiatrist;